var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"friendicon",class:_vm.friendStateStyle,attrs:{"title":_vm.titleText}},[_c('div',{staticClass:"lettercontainer"},[_c('div',{staticClass:"lettertext"},[_vm._v(" "+_vm._s(_vm.letter)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }